import { useTranslation } from 'next-i18next';

import { PUBLIC_IMAGES } from '../../../config';

export const QrCodeBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute top-3/4 flex h-[500px] w-full flex-col overflow-hidden bg-black-800 md:flex-row">
      <div className="relative h-full w-full">
        <div
          className="absolute h-full w-full bg-cover bg-center"
          style={{ backgroundImage: `url(${PUBLIC_IMAGES.QR_IMAGE})` }}
        />
        <div className="absolute h-[101%] w-[101%] bg-gradient-to-b from-transparent to-black-800 md:bg-gradient-to-r" />
      </div>

      <div className="h-1/3 w-full flex-none bg-black-800 md:h-full md:w-1/2" />

      <div className="absolute flex h-full w-full items-end pb-2 md:items-center">
        <div className="container flex flex-col items-end">
          <p className="text-right font-extrabold text-white md:text-3xl">{t('additional-services.qr-description1')}</p>

          <p className="py-1 text-right text-2xl font-extrabold text-green md:py-3 md:text-5xl lg:py-4">
            {t('additional-services.qr-code')}
          </p>

          <p className="text-right font-extrabold text-white md:text-3xl">{t('additional-services.qr-description2')}</p>
        </div>
      </div>

      <div
        className="absolute right-1/2 top-1/3 h-[300px] w-[300px] rotate-45 bg-cover md:right-0 md:top-0 md:h-[400px] md:w-[400px] lg:bottom-1/2 lg:right-1/4"
        style={{ backgroundImage: `url(${PUBLIC_IMAGES.QR_CODE})` }}
      />

      <div
        className="absolute left-1/2 top-2/3 h-[300px] w-[300px] rotate-45 bg-cover md:left-3/4 md:top-3/4 md:h-[400px] md:w-[400px] lg:top-1/2"
        style={{ backgroundImage: `url(${PUBLIC_IMAGES.QR_CODE})` }}
      />

      <div
        className="none absolute bottom-3/4 left-3/4 hidden h-[400px] w-[400px] rotate-45 bg-cover lg:block"
        style={{ backgroundImage: `url(${PUBLIC_IMAGES.QR_CODE})` }}
      />
    </div>
  );
};
